import { createRoute, redirect } from "@tanstack/react-router";
import { OwnerMetricDashboardRoute } from "@/components/owner-metrics/owner-metric-dashboard";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/owner-metrics/$ownerId",
  validateSearch: (search: Record<string, unknown>): { from?: string; ownerDetailId?: string } => ({
    from: (search.from as string) || undefined,
    ownerDetailId: (search.ownerDetailId as string) || undefined,
  }),
  loader: async ({ params }) => {
    const [pipelinesRes, ownerByIdRes, ownerSearchRes, accessRes] = await Promise.all([
      fetch("/api/hubspot/pipelines/deals"),
      fetch(`/api/owners/${params.ownerId}`),
      fetch(`/api/owners?search=${params.ownerId}&pageSize=1`),
      fetch(`/api/org-chart/can-view/${params.ownerId}`),
    ]);
    const pipelines = pipelinesRes.ok ? ((await pipelinesRes.json()).results ?? []) : [];
    let ownerName: string | null = null;
    if (ownerByIdRes.ok) {
      const data = await ownerByIdRes.json();
      if (data.owner) ownerName = `${data.owner.firstName} ${data.owner.lastName}`.trim();
    } else if (ownerSearchRes.ok) {
      const data = await ownerSearchRes.json();
      const match = data.owners?.[0];
      if (match) ownerName = `${match.firstName} ${match.lastName}`.trim();
    }
    const access = accessRes.ok ? await accessRes.json() : { canView: false, isAdmin: false };
    if (!access.canView) {
      throw redirect({ to: "/my-dashboard" });
    }
    return { pipelines, ownerName, isAdmin: access.isAdmin };
  },
  component: OwnerMetricDashboardRoute,
});
